<template>

	<!-- content -->
	<div id="content" class="error">
		<div class="container">
			<h1 class="error-title">
				페이지를 찾을 수 없습니다.
			</h1>
			<p class="error-desc">
				페이지가 존재하지 않거나, 사용할 수 없는 페이지입니다. <br>입력하신 주소가 정확한지 다시 한번 확인해 주시기 바랍니다.
			</p>
			<div class="btn-wrap">
				<a href="/" class="btn btn-lg btn-gray-dark">홈으로 이동</a>
			</div>
		</div>
	</div>
	<!--//content -->

</template>

<script>
export default {
	name: "error"
}
</script>

<style scoped>

</style>